import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import { forgetPasswordSaga, resetPasswordSaga, updatePasswordSaga } from "./auth/password/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import campaignSaga from "./campaign/saga"
import roleSaga from "./roles/saga" //TODO: Keep the names consistent, plural or singular -
import usersSaga from "./accounts/saga"
import AdSaga from "./creatives/saga"
import changeHistorySaga from "./change-history/saga"
import adminChangeHistorySaga from "./admin-change-history/saga"
import adminChangeHistoryFiltersSaga from "./admin-change-history-filters/saga"
import sfCommonData from "./sf_common_data/saga"
import brandsSaga from "./brands/saga"
import DashboardSaga from "./dashboard/saga"
import analyticsSaga from "./analytics/saga"
import conversionsSaga from "./conversions/saga"
import adGroupLocationsSaga from "./ad-group-locations/saga"
import adGroupAdSaga from "./ad-group-ad/saga"
import BannerMessagesSaga from "./banner-messages/saga"
import ReceiptsSaga from "./receipts/saga"
import PaymentMethodsSaga from "./payment_methods/saga"
import UserSmartViewsSaga from "./user_smart_views/saga"
import ScheduledReports from "./scheduled_reports/saga"
import AdminScheduledReports from "./admin/admin_scheduled_reports/saga"
import adminUsersSaga from "./admin/users/saga"
import adminUserLoginSaga from "./admin/user-login/saga"
import whitelistedBrandLoginSaga from "./admin/whitelisted-brands/saga"
import featuresFlagsSaga from "./admin/feature-flags/saga"
import SignUpAdminUserSaga from "./admin/Authentication/signup/saga"
import LoginAdminUserSaga from "./admin/Authentication/login/saga"
import adminUserRolesSaga from "./admin/roles/saga"
import adminNotificationsSaga from "./admin/admin-notifications/saga"
import AdminManageInternalUsersSaga from "./admin/admin-internal-user/saga"
import ResetAdminPasswordSaga from "./admin/Authentication/password/saga"
import InvoicesSaga from "./invoices/saga"
import InsuranceCarriersSaga from "./insurance-carrier/saga"
import UnlockAdminUserSaga from "./admin/Authentication/Unlock-Account/saga"
import adminUserColumnPreferenceSaga from "./admin/sticky-columns/saga"
import adminDashboardColumnPreferenceSaga from "./admin/admin-dashboard-sticky-columns/saga"
import NotificationsSaga from "./notifications/saga"
import UpdateClientUserSaga from "./EditedByAdmin/saga"
import userCampaignColumnPreferenceSaga from "./user_column_preference/campaign-sticky-columns/saga"
import userAdGroupColumnPreferenceSaga from "./user_column_preference/adgroup-sticky-columns/saga"
import userSourceSettingColumnPreferenceSaga from "./user_column_preference/source-setting-sticky-columns/saga"
import EmailEventsSaga from "./email-events/saga"
import LeadPricesSaga from "./lead_prices/saga"
import QuoteFunnelsPricesSaga from "./quote_funnels_prices/saga"
import QuoteFunnelsStatsSaga from "./quote-funnels-stats/saga"
import MarketplaceStatsSaga from "./marketplace-stats/saga"
import CallPricesSaga from "./call_prices/saga"
import APITokensSaga from "./api-tokens/saga"
import AdminInvoicesSaga from "./admin/admin-invoices/saga"
import CampaignAnalysisSaga from "./campaign-analysis/saga"
import userLeadProfileColumnPreferenceSaga from "./user_column_preference/lead-profile-sticky-columns/saga"
import userCallProfileColumnPreferenceSaga from "./user_column_preference/call-profile-sticky-columns/saga"
import userLeadColumnPreferenceSaga from "./user_column_preference/lead-sticky-columns/saga"
import userCallColumnPreferenceSaga from "./user_column_preference/call-sticky-columns/saga"
import userCallsDashboardColumnPreferenceSaga from "./user_column_preference/calls-dashboard-sticky-columns/saga"
import userClicksDashboardColumnPreferenceSaga from "./user_column_preference/clicks-dashboard-sticky-column/saga"
import userLeadsDashboardColumnPreferenceSaga from "./user_column_preference/leads-dashboard-sticky-column/saga"
import userConversionLogColumnPreferenceSaga from "./user_column_preference/conversion-log-sticky-columns/saga"
import userAnalyticsColumnPreferenceSaga from "./user_column_preference/analytics-sticky-columns/saga"
import ZipTiersSaga from "./zip_tiers/saga"
import IntegrationsSaga from "./integration/saga"
import IntegrationV2Saga from "./integration_v2/saga"
import CallsSaga from "./calls/saga"
import LeadsSaga from "./leads/saga"
import NotificationsTerminalSaga from "./notifications-terminal/saga"
import ClientEmailEventsSaga from "./client-email-events/saga"
import AdminInsuranceCarriersSaga from "./admin-insurance-carrier/saga"
import AdminUserActivitySaga from "./user-activity/saga"
import TermsOfServicesSaga from "./terms-of-service/saga"
import AdminRefundReasonsSaga from "./admin-refund-reasons/saga"
import AdminPaymentTermsSaga from "./admin-payment-terms/saga"
import AdminBillingEventsSaga from "./admin-billing-events/saga"
import AdminTwilioNumbers from "./admin-twilio-numbers/saga"
import AdminLeadPricesSaga from "./admin-lead-prices/saga"
import AdminCallPricesSaga from "./admin-call-prices/saga"
import AdminDashboardSaga from "./admin/dashboard/saga"
import AdminLeadRefundsSaga from "./admin-lead-refunds/saga"
import AdminSfFiltersSaga from "./admin-sf-filters/saga"
import AdgroupNotesSaga from "./notes/adgroup_notes/saga"
import CampaignNotesSaga from "./notes/campaign_notes/saga"
import SourceSettingsNotesSaga from "./notes/source_settings_notes/saga"
import LeadNotesSaga from "./notes/lead_notes/saga"

import GetPlatformSettingsSaga from "./platform-settings/saga"
import AdminPlatformSettingsSaga from "./admin-platform-settings/saga"
import AdminFilterPackagesSaga from "./admin-filter-packages/saga"
import CustomizeColumnsOrderSaga from "./customize-columns-order/saga"
import QuoteFunnelSaga from "./quote_funnels/saga"
import QuoteFunnelAnswersAgentProfileSaga from "./quote_funnels/answers/saga"
import ProspectsSaga from "./prospects/saga"
import AllProspectsSaga from "./fetch-all-prospects/saga"
import QuoteFunnelsCCPASaga from "./quotes_funnel_ccpa/saga"
import userSyndiClicksDashboardColumnPreferenceSaga from "./user_column_preference/syndi-clicks-dashboard-sticky-column/saga"
import CustomizeOrderSaga from "./customize-order/saga"
import CustomizeOrderForAdminSaga from "./admin/admin-customize-column-order/saga"
import ExportEmailSaga from "./export-email/saga"
import CallSummarySaga from "./call-summary/saga"
import AnswerFromQuerySaga from "./call-summary-qa/saga"
import DevDashboardSaga from "./admin/dev-dashboard/saga"
import ConsentConfirmationSaga from "./consent-confirmation/saga"
import StatusMonitorSaga from "./admin/status-monitor/saga"
import AutomationTestsSaga from "./admin/automation-tests/saga"
import RdsMonitorSaga from "./admin/rds-monitor/saga"
import adminIntegrationLogsSaga from "./admin/admin-integration-logs/saga"
import adminBulkEditJobsSaga from "./admin/admin-bulk-edit-jobs/saga"
import RefundPolicySaga from "./refund-policy/saga"
import AdminCampaignFulFillmentSaga from "./admin/admin-campaign-fulfillment/saga"
import ClientCampaignFulfillmentSaga from "./campaign-fulfillment/saga"
import DashboardV4Saga from "./dashboard-v4/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(forgetPasswordSaga),
    fork(resetPasswordSaga),
    fork(updatePasswordSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(usersSaga),
    fork(campaignSaga),
    fork(roleSaga),
    fork(AdSaga),
    fork(changeHistorySaga),
    fork(adminChangeHistorySaga),
    fork(adminChangeHistoryFiltersSaga),
    fork(brandsSaga),
    fork(sfCommonData),
    fork(DashboardSaga),
    fork(analyticsSaga),
    fork(conversionsSaga),
    fork(adGroupLocationsSaga),
    fork(adGroupAdSaga),
    fork(BannerMessagesSaga),
    fork(ReceiptsSaga),
    fork(PaymentMethodsSaga),
    fork(UserSmartViewsSaga),
    fork(ScheduledReports),
    fork(AdminScheduledReports),
    fork(adminUsersSaga),
    fork(adminUserLoginSaga),
    fork(whitelistedBrandLoginSaga),
    fork(featuresFlagsSaga),
    fork(SignUpAdminUserSaga),
    fork(LoginAdminUserSaga),
    fork(adminUserRolesSaga),
    fork(adminNotificationsSaga),
    fork(AdminManageInternalUsersSaga),
    fork(ResetAdminPasswordSaga),
    fork(InvoicesSaga),
    fork(InsuranceCarriersSaga),
    fork(UnlockAdminUserSaga),
    fork(adminUserColumnPreferenceSaga),
    fork(adminDashboardColumnPreferenceSaga),
    fork(NotificationsSaga),
    fork(UpdateClientUserSaga),
    fork(userCampaignColumnPreferenceSaga),
    fork(userAdGroupColumnPreferenceSaga),
    fork(userSourceSettingColumnPreferenceSaga),
    fork(userLeadProfileColumnPreferenceSaga),
    fork(userCallProfileColumnPreferenceSaga),
    fork(userLeadColumnPreferenceSaga),
    fork(userCallColumnPreferenceSaga),
    fork(userCallsDashboardColumnPreferenceSaga),
    fork(userClicksDashboardColumnPreferenceSaga),
    fork(userLeadsDashboardColumnPreferenceSaga),
    fork(userConversionLogColumnPreferenceSaga),
    fork(userAnalyticsColumnPreferenceSaga),
    fork(userSyndiClicksDashboardColumnPreferenceSaga),
    fork(ZipTiersSaga),
    fork(EmailEventsSaga),
    fork(LeadPricesSaga),
    fork(QuoteFunnelsPricesSaga),
    fork(QuoteFunnelsStatsSaga),
    fork(MarketplaceStatsSaga),
    fork(CallPricesSaga),
    fork(CallsSaga),
    fork(LeadsSaga),
    fork(APITokensSaga),
    fork(AdminInvoicesSaga),
    fork(CampaignAnalysisSaga),
    fork(IntegrationsSaga),
    fork(IntegrationV2Saga),
    fork(NotificationsTerminalSaga),
    fork(ClientEmailEventsSaga),
    fork(AdminInsuranceCarriersSaga),
    fork(AdminUserActivitySaga),
    fork(TermsOfServicesSaga),
    fork(AdminRefundReasonsSaga),
    fork(AdminPaymentTermsSaga),
    fork(AdminBillingEventsSaga),
    fork(AdminTwilioNumbers),
    fork(AdminLeadPricesSaga),
    fork(AdminCallPricesSaga),
    fork(AdminLeadRefundsSaga),
    fork(AdminDashboardSaga),
    fork(AdminSfFiltersSaga),
    fork(AdgroupNotesSaga),
    fork(CampaignNotesSaga),
    fork(SourceSettingsNotesSaga),
    fork(LeadNotesSaga),
    fork(GetPlatformSettingsSaga),
    fork(AdminPlatformSettingsSaga),
    fork(AdminFilterPackagesSaga),
    fork(CustomizeColumnsOrderSaga),
    fork(QuoteFunnelSaga),
    fork(QuoteFunnelAnswersAgentProfileSaga),
    fork(ProspectsSaga),
    fork(AllProspectsSaga),
    fork(QuoteFunnelsCCPASaga),
    fork(CustomizeOrderSaga),
    fork(CustomizeOrderForAdminSaga),
    fork(ExportEmailSaga),
    fork(CallSummarySaga),
    fork(AnswerFromQuerySaga),
    fork(DevDashboardSaga),
    fork(ConsentConfirmationSaga),
    fork(StatusMonitorSaga),
    fork(AutomationTestsSaga),
    fork(RdsMonitorSaga),
    fork(adminIntegrationLogsSaga),
    fork(adminBulkEditJobsSaga),
    fork(RefundPolicySaga),
    fork(AdminCampaignFulFillmentSaga),
    fork(ClientCampaignFulfillmentSaga),
    fork(DashboardV4Saga),
  ])
}
